import { type Conflict, type ReorderConflict } from '@editor2/types/conflict';
import { type CourseState } from '@editor2/types/courseState';
import {
	restoreDeletedPageGroup,
	updatePageGroupReorderConflictWithIncoming
} from '@editor2/services/conflictResolutionService';
import { getChapterByPageGroupId } from '@editor2/components/CourseChangesDiff/helpers';

export class PageGroupDeletedModifiedConflictResolver {
	acceptCurrent = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		const { entityId, incoming } = conflict;
		state.initialCourse.page_groups.entities[entityId] = incoming as any;
	};

	acceptIncoming = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		const { entityId, incoming } = conflict;
		restoreDeletedPageGroup(state, entityId);

		state.page_groups.entities[entityId] = incoming as any;

		const initialParent = getChapterByPageGroupId(state.initialCourse.chapters, entityId);
		updatePageGroupReorderConflictWithIncoming(state, initialParent.family_id);
	};

	acceptBoth = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		throw new Error('Accept both is not allowed for this type of conflict');
	};
}
